import React, { useEffect, useState, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";
import resetAlt from "../../assets/images/reset-alt.svg";
import reset from "../../assets/images/reset.svg";
import infoicon from "../../assets/images/infoicon.svg";
import "./Search.css";
import { GlobalContext } from "../../App";
import { Tooltip } from "primereact/tooltip";
import { OverlayPanel } from "primereact/overlaypanel";

interface Props {
  setMountQuery: React.Dispatch<
    React.SetStateAction<{
      kg: string;
      rpm: string;
      noOfMount: string;
    }>
  >;
  updatorFunction: any;
}

function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

const setEmpty = (val: any) => (val ? val : "");

const handleValueChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  cb: Function
) => {
  const { min, max, value } = e.target;
  const re = /^[0-9\b]+$/;
  if (
    (Number(value) >= Number(min) &&
      Number(value) <= Number(max) &&
      value.length <= 6 &&
      re.test(value)) ||
    value === ""
  ) {
    cb(value);
  }
};

const Search: React.FC<Props> = ({ setMountQuery, updatorFunction }) => {
  const ctx = useContext(GlobalContext);
  const [searchParams] = useSearchParams();
  const [kg, setKg] = useState(
    setEmpty(ctx.kg ? ctx.kg : searchParams.get("kg"))
  );
  const [rpm, setRpm] = useState(
    setEmpty(ctx.rpm ? ctx.rpm : searchParams.get("rpm"))
  );
  const [noOfMount, setNoOfMount] = useState(
    setEmpty(ctx.noOfMount ? ctx.noOfMount : searchParams.get("noOfMount"))
  );
  let location = useLocation();
  const { t } = useTranslation();
  const triggerReset = () => {
    //reseting the values when the user has added new things
    ctx.updateGlobalCtx({
      ...ctx,
      failSafe: false,
      currentView: "GRID",
      currentCategory: "",
    });
  };
  useEffect(() => {
    if (Number(rpm) > 99) {
      setMountQuery({ kg, rpm, noOfMount });
    }
  }, [kg, rpm, noOfMount, setMountQuery]);

  useEffect(() => {
    if (Number(rpm) > 99) {
      updatorFunction({ kg, rpm, noOfMount });
    }
  }, [location]);
  const resetValue = () => {
    setMountQuery({ kg: "", rpm: "", noOfMount: "" });
    setKg("");
    setRpm("");
    setNoOfMount("");
  };
  const op = useRef<OverlayPanel>(null);
  return (
    <section className="mt-4 searchbox grid">
      <div className="mb-2 md:mb-0 col-12 md:col-4 lg:col-3 flex flex-column justify-content-between ">
        <label className="block pb-2 " htmlFor="kg">
          {t("WEIGHT")}
        </label>
        <input
          id="kg"
          className="block tb-input"
          value={kg}
          onChange={(e) => {
            handleValueChange(e, setKg);
            triggerReset();
          }}
          min={0}
          max={999999}
          autoComplete="off"
        />
        <div className="something"></div>
      </div>
      <div className="mb-2 md:mb-0 col-12 md:col-4 lg:col-3 flex flex-column justify-content-between relative">
        <label className="block pb-2 " htmlFor="rpm">
          {t("RPM")}
        </label>
        <input
          id="rpm"
          className={`block tb-input `}
          value={rpm}
          onChange={(e) => {
            handleValueChange(e, setRpm);
            triggerReset();
          }}
          min={0}
          max={999999}
          autoComplete="off"
        />
        {rpm === "" ? <div className="something"></div> : ""}
        {rpm && Number(rpm) > 99 ? <div className="something"></div> : ""}
        {rpm && Number(rpm) < 100 ? (
          <>
            <div className="error-something"></div>
            <small className="error err-abs absolute">{t("MIN_RPM")}</small>
          </>
        ) : (
          ""
        )}
      </div>
      <div className="col-12 md:col-3 lg:col-3 flex flex-column justify-content-between">
        <label htmlFor="noOfMount" className="block pb-2 ">
          {t("MOUNT")}
        </label>
        <input
          id="noOfMount"
          className="block tb-input"
          value={noOfMount}
          onChange={(e) => {
            handleValueChange(e, setNoOfMount);
            triggerReset();
          }}
          min={0}
          max={999999}
          autoComplete="off"
        />
        <div className="something"></div>
      </div>
      <div className="text-left relative img-btn col-12 md:col-1 lg:col-1 xl:col-1">
        <div className="absolute flex align-items-center">
          <button
            onClick={resetValue}
            disabled={kg || rpm || noOfMount ? false : true}
          >
            <img
              src={kg || rpm || noOfMount ? reset : resetAlt}
              alt="Reset"
              title={t("RESET")}
            />{" "}
          </button>
          <button
            className="ml-2 lg:ml-3 "
            onClick={(e) => {
              op.current?.toggle(e);
            }}
          >
            <img
              src={infoicon}
              className="pointer"
              height={"21px"}
              onMouseEnter={(e) =>
                detectMob() ? "" : op.current?.show(e, null)
              }
              onMouseLeave={(e) => (detectMob() ? "" : op.current?.hide())}
              onClick={(e) => {
                op.current?.toggle(e);
              }}
            />{" "}
          </button>
        </div>

        {/* <img
          src={resetAlt}
          className="custom-target-icon"
          style={{ cursor: "pointer" }}
          onMouseEnter={(e) => op.current?.toggle(e)}
          onMouseLeave={(e) => op.current?.toggle(e)}
          onClick={(e) => op.current?.toggle(e)}
        ></img> */}
      </div>
      <OverlayPanel
        ref={op}
        className="ovelaycontent"
        breakpoints={{ "640px": "80vw" }}
        style={{ maxWidth: "50ch" }}
      >
        <p className="mb-3  text-sm font-primary">{t("SEARCH_INFO_1")}</p>
        <p className="mb-3  text-sm font-primary">{t("SEARCH_INFO_2")}</p>
        <p className=" text-sm font-primary">{t("SEARCH_INFO_3")}</p>
      </OverlayPanel>
    </section>
  );
};

export default Search;
